import React, { useState, useEffect } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { t } from './../i18n';
import useApp from '../AppContext';
import ListSuppliers from './ListSuppliers';
import { Modal } from 'react-bootstrap';
import { ErrorAlert } from '../crud/utils';
import BookingFrequency from './BookingFrequency';
import './Calendar.css';
import { format } from 'date-fns';
import { loadListAllObjects, loadDataObject } from './CalendarUtils';
import { callApi } from '../crud/utils';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CustomDropdown from '../Components/CustomDropdown';
import WarningIcon from '@mui/icons-material/Warning';

export default function ScheduledBookingForm(props) {
    const app = useApp();
    const language = app.sessionToken?.Language;

    const [supplier, setSupplier] = useState('');
    const [selectedTaskId, setSelectedTaskId] = useState('');
    const [serverUrl] = useState(app.serverUrl);
    const [phone, setPhone] = useState('');
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [allColumnsObj, setAllColumnsObj] = useState(null);
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [warningMessage, setWarningMessage] = useState('');
    const [warningShown, setWarningShown] = useState(false);
    const [showBookingFrequencyModal, setShowBookingFrequencyModal] = useState(false);
    const [bookingFrequencyData, setBookingFrequencyData] = useState(null);
    const [ymsCategories, setYmsCategories] = useState([]);
    const [ymsTasks, setYmsTasks] = useState([]);
    const [showSuccess, setShowSuccess] = useState(false);
    const [savedSupplier, setSavedSupplier] = useState(null);
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [palletCount, setPalletCount] = useState('');
    const [itemCount, setItemCount] = useState('');

    useEffect(() => {
        async function getDefaultLayouts() {
            if (!serverUrl) return;
            if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) {
                let allobj = await loadListAllObjects(serverUrl, props.userToken)
                setAllColumnsObj(allobj);
            }
        }
        getDefaultLayouts();
    }, [serverUrl, props.userToken, allColumnsObj]);

    useEffect(() => {
        const fetchTasksData = async () => {
            if (!allColumnsObj || Object.keys(allColumnsObj).length === 0) return;

            const objectName = "Yms_Tasks";

            const updatedColumnsObj = { ...allColumnsObj };

            const exists = updatedColumnsObj.Yms_Tasks.columns.some(
                c => c.columnName === "DefaultFlg"
            );

            if (!exists) {
                updatedColumnsObj.Yms_Tasks.columns.push({
                    columnName: "DefaultFlg",
                    dataType: "Double"
                });
            }

            try {
                const responseObj = await loadDataObject(
                    serverUrl,
                    props.userToken,
                    objectName,
                    updatedColumnsObj,
                    [],
                    {},
                    {
                        filterName: "customfilter",
                        appendFilter: "",
                    }
                );

                if (Array.isArray(responseObj) && responseObj.length > 0) {
                    setYmsTasks(responseObj);
                    const defaultTasks = responseObj.filter(task => task.DefaultFlg === true);
                    if (defaultTasks.length === 1) {
                        setSelectedTaskId(String(defaultTasks[0].TaskId));
                    }
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchTasksData();
    }, [allColumnsObj, serverUrl, app.sessionToken, props.userToken]);

    useEffect(() => {
        const fetchCategoriesData = async () => {
            if (!allColumnsObj || Object.keys(allColumnsObj).length === 0) return;

            const objectName = "Yms_Categories";
            const prms = [];
            const prmValues = {};

            const defaultVariables = {
                filterName: "customfilter",
                appendFilter: "",
            };

            try {
                const responseObj = await loadDataObject(
                    serverUrl,
                    props.userToken,
                    objectName,
                    allColumnsObj,
                    prms,
                    prmValues,
                    defaultVariables
                );

                if (Array.isArray(responseObj) && responseObj.length > 0) {
                    setYmsCategories(responseObj);
                }
            } catch (error) {
                console.error("Error fetching Yms_Categories`:", error);
            }
        };

        fetchCategoriesData();
    }, [allColumnsObj, serverUrl, app.sessionToken, props.userToken]);


    const handleOpenSuppliersModal = () => {
        setSavedSupplier(selectedSupplier);
        setShowSupplierModal(true);
    };

    const handleCloseSuppliersModal = () => {
        setSelectedSupplier(savedSupplier);
        setShowSupplierModal(false);
    };

    useEffect(() => {
        if (!selectedSupplier) {
            setSupplier('');
        }
    }, [selectedSupplier]);

    const handleSelectSupplier = (supplier) => {
        if (selectedSupplier?.SupplierId === supplier.SupplierId) {
            setSelectedSupplier(null);
        } else {
            setSelectedSupplier(supplier);
        }
    };


    const findSelectSupplier = (supplier) => {
        return selectedSupplier?.SupplierId === supplier.SupplierId;
    };

    const handleSaveSuppliers = () => {
        if (!selectedSupplier) {
            setErrorMessage(t('ModalBooking.selectOneSupplierWarning', language));
            return;
        }

        setSupplier(selectedSupplier);
        setShowSupplierModal(false);
    };

    const isDurationDisabled = (palletCount && palletCount !== '0') || (itemCount && itemCount !== '0');

    return (
        <>
            <div style={{ zIndex: 9999 }}>
                <ErrorAlert message={errorMessage} setMessage={setErrorMessage} language={language} />
            </div>
            {showSuccess ? (
                <div className="success-pre-booking-modal">
                    <img src='./images/Pre-bookingSuccess.svg' alt='Pre Booking Success' className="mb-3" />
                    <h4 style={{ margin: '40px 0px' }}>
                        {t('ModalBooking.successPreBooking', language)}
                    </h4>
                    <CheckCircleIcon />
                </div>
            ) : (
                <>
                    <div className="header-form-new-booking">
                        <h2>
                            <i className="bi bi-clock icon-badge"></i>
                            {(t('ModalBooking.createScheduledBookingTitle', language))}
                        </h2>
                    </div>
                    
                    <div className="scheduled-booking-progress">
                        <div className="progress-bar-container">
                            <div
                                className={`progress-bar-fill ${(() => {
                                    let filled = 0;
                                    if (supplier?.SupplierId) filled++;
                                    if (selectedTaskId) filled++;
                                    if (bookingFrequencyData) filled++;
                                    return filled === 3 ? 'completed' : '';
                                })()}`}
                                style={{
                                    width: `${(() => {
                                        let filled = 0;
                                        if (supplier?.SupplierId) filled++;
                                        if (selectedTaskId) filled++;
                                        if (bookingFrequencyData) filled++;
                                        return (filled / 3) * 100;
                                    })()}%`
                                }}
                            >
                                <div className="progress-bar-shimmer"></div>
                            </div>
                        </div>
                        <div className="progress-text">
                            {(() => {
                                let filled = 0;
                                if (supplier?.SupplierId) filled++;
                                if (selectedTaskId) filled++;
                                if (bookingFrequencyData) filled++;
                                if (filled === 3) {
                                    return (
                                        <span className="progress-complete">
                                            <i className="bi bi-check-circle-fill"></i>
                                            {t('ModalBooking.allRequiredFieldsCompleted', language)}
                                        </span>
                                    );
                                }
                                return `${filled}/3 ${t('ModalBooking.requiredFieldsCompleted', language)}`;
                            })()}
                        </div>
                    </div>

                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="label-to-left">
                                {t('ModalBooking.supplierTitleForm', language)}&nbsp;<span className='required-bullet'>*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={supplier?.SocialSecurityNo || ''}
                                readOnly
                                onClick={handleOpenSuppliersModal}
                                placeholder={t('ModalBooking.supplierPlaceholder', language)}
                                style={{ cursor: 'pointer' }}
                            />

                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="label-to-left">
                                {t('ModalBooking.yardTaskType', language)}&nbsp;<span className='required-bullet'>*</span>
                            </Form.Label>
                            <CustomDropdown
                                options={ymsTasks.map(cat => ({
                                    value: String(cat.TaskId),
                                    label: cat.Descr1
                                }))}
                                value={selectedTaskId}
                                onChange={(e) => setSelectedTaskId(e.target.value)}
                                showEmptyOption={true}
                                placeholder={t('ModalBooking.yardTaskType', language)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="label-to-left">
                                {t('ModalBooking.categoryTitleForm', language)}
                            </Form.Label>
                            <CustomDropdown
                                options={ymsCategories.map(cat => ({
                                    value: String(cat.CategoryId),
                                    label: cat.Descr1
                                }))}
                                value={selectedCategoryId}
                                onChange={(e) => setSelectedCategoryId(e.target.value)}
                                showEmptyOption={true}
                                placeholder={t('ModalBooking.categoryTitleForm', language)}
                            />
                        </Form.Group>
                        
                        {warningShown && warningMessage && (
                            <div style={{
                                backgroundColor: 'var(--bg-primary)',
                                borderLeft: '4px solid #f59f00',
                                borderRadius: '11px',
                                padding: '16px 20px',
                                marginBottom: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                borderRight: '2px solid var(--border-color)',
                                borderBottom: '2px solid var(--border-color)',
                                borderTop: '2px solid var(--border-color)'
                            }}>
                                <div style={{
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #ffd43b 0%, #f59f00 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <WarningIcon style={{ fontSize: '18px', color: 'white' }} />
                                </div>
                                <span style={{ fontSize: '14px', fontWeight: '500', color: 'var(--text-primary)', textAlign: 'left' }}>{warningMessage}</span>
                            </div>
                        )}

                        <Form.Group className="mb-3">
                            <Form.Label className="label-to-left">
                                {t('ModalBooking.palletCountTitleForm', language)}
                            </Form.Label>
                            <Form.Control
                                type="number"
                                value={palletCount}
                                onChange={(e) => {
                                    setPalletCount(e.target.value);
                                    if (e.target.value && e.target.value !== '0' && !warningShown) {
                                        setWarningMessage(t('ModalBooking.durationWillBeCalculated', language) || 'Η διάρκεια του booking θα υπολογιστεί βάσει των επιλογών που έχουν τεθεί.');
                                        setWarningShown(true);
                                    } else if ((!e.target.value || e.target.value === '0') && (!itemCount || itemCount === '0')) {
                                        setWarningMessage('');
                                        setWarningShown(false);
                                    }
                                }}
                                min="0"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="label-to-left">
                                {t('ModalBooking.itemCountTitleForm', language)}
                            </Form.Label>
                            <Form.Control
                                type="number"
                                value={itemCount}
                                onChange={(e) => {
                                    setItemCount(e.target.value);
                                    if (e.target.value && e.target.value !== '0' && !warningShown) {
                                        setWarningMessage(t('ModalBooking.durationWillBeCalculated', language) || 'Η διάρκεια του booking θα υπολογιστεί βάσει των επιλογών που έχουν τεθεί.');
                                        setWarningShown(true);
                                    } else if ((!e.target.value || e.target.value === '0') && (!palletCount || palletCount === '0')) {
                                        setWarningMessage('');
                                        setWarningShown(false);
                                    }
                                }}
                                min="0"
                            />
                        </Form.Group>



                        <Form.Group className="mb-3">
                            <Form.Label className="label-to-left">{(t('ModalBooking.bookingFrequencyTitleForm', language))}&nbsp;<span className='required-bullet'>*</span></Form.Label>
                            <Form.Control
                                type="text"
                                value={
                                    bookingFrequencyData
                                        ? `${t(`bookingFrequency.${bookingFrequencyData.frequency}`, language)}, ${bookingFrequencyData.startTime}${!isDurationDisabled ? ` - ${bookingFrequencyData.duration} ${t("ModalBooking.minutes", language)}` : ''}` +
                                        (bookingFrequencyData.endOption === 'after'
                                            ? `, ${t('bookingFrequency.endAfter', language)} ${bookingFrequencyData.occurrences} ${t('bookingFrequency.times', language)}`
                                            : bookingFrequencyData.endOption === 'until'
                                                ? `, ${t('bookingFrequency.endBy', language)} ${format(new Date(bookingFrequencyData.endByDate), 'dd/MM/yyyy')}`
                                                : `, ${t('bookingFrequency.never', language)}`)
                                        : ''
                                }
                                onClick={() => setShowBookingFrequencyModal(true)}
                                placeholder={t('ModalBooking.bookingFrequencyPlaceholder', language)}
                                readOnly
                                style={{ cursor: 'pointer' }}
                            />

                        </Form.Group>
                        <Row style={{ marginBottom: '60px' }}>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="label-to-left">
                                        {t('ModalBooking.descrSupplierTitleForm', language)}
                                    </Form.Label>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        flexWrap: 'wrap',
                                        minHeight: '35px'
                                    }}>
                                        {supplier?.Name1 ? (
                                            <span style={{
                                                backgroundColor: 'var(--color-main-background)',
                                                color: 'white',
                                                padding: '6px 12px',
                                                borderRadius: '22px',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'inline-block'
                                            }}>
                                                {supplier.Name1}
                                            </span>
                                        ) : (
                                            <span style={{
                                                backgroundColor: 'var(--bg-secondary)',
                                                border: '2px dashed var(--border-color)',
                                                color: 'var(--text-secondary)',
                                                padding: '6px 12px',
                                                borderRadius: '22px',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="bi bi-info-circle"></i>
                                                {t('ModalBooking.autoFilledField', language)}
                                            </span>
                                        )}
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="label-to-left">
                                        {t('ModalBooking.phoneTitleForm', language)}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        placeholder={t('ModalBooking.phoneTitleForm', language)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className='next-new-event-in-calendar'>
                            <Button
                                disabled={!bookingFrequencyData || !selectedTaskId || !supplier?.SupplierId}
                                onClick={async () => {
                                    const date = props.selectTtimeSlot || new Date();

                                    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

                                    const warehouseid = props.warehouseid || '';
                                    const dataToSave = {
                                        supplierId: supplier?.SupplierId,
                                        selectedTaskId,
                                        phone,
                                        warehouseid,
                                        currentDate: formattedDate,
                                        bookingFrequencyData,
                                        selectedCategoryId,
                                        palletCount: palletCount || 0,
                                        itemCount: itemCount || 0
                                    };
                                    try {
                                        const response = await callApi(
                                            'POST',
                                            `${serverUrl}/api/PostPreBooking`,
                                            props.userToken,
                                            dataToSave
                                        );
                                        if (response === 'ok') {
                                            setShowSuccess(true);
                                            setTimeout(() => {
                                                props.setIsModalOpenScheduled(false);
                                            }, 2000);
                                        }


                                    } catch (error) {
                                        let message = t('ModalBooking.errorSavingBooking', language);
                                        if (error?.response?.data?.Message) {
                                            message = error.response.data.Message;
                                        } else if (error?.message) {
                                            message = error.message;
                                        }
                                        setErrorMessage(message);
                                    }
                                }}
                            >
                                {t('common.saveButton', language)} <i className="bi bi-save" style={{ marginLeft: "5px" }}></i>
                            </Button>
                        </div>

                    </Form >
                </>
            )}
            <Modal
                show={showSupplierModal}
                onHide={handleCloseSuppliersModal}
                size="xl"
                centered
                animation={true}
                backdrop="static"
            >
                <Modal.Header closeButton className="border-0" />
                <Modal.Body className="text-center modal-pos">
                    <svg className="background-svg" viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2301_81)">
                            <ellipse cx="413.131" cy="422.366" rx="413.131" ry="422.366"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 965.542 1192.45)"
                                fill="var(--color-main-background)" />
                            <ellipse cx="516.414" cy="527.957" rx="516.414" ry="527.957"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1113.22 1195.26)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                            <ellipse cx="650.299" cy="664.835" rx="650.299" ry="664.835"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1304.66 1198.9)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2301_81">
                                <rect width="1920" height="1080" fill="white" transform="matrix(-1 0 0 1 1920 0)" />
                            </clipPath>
                        </defs>
                    </svg>

                    <div style={{ zIndex: 9999 }}>
                        <ErrorAlert message={errorMessage} setMessage={setErrorMessage} language={language} />
                    </div>

                    <div className="mb-3 position-relative" style={{ zIndex: 1 }}>
                        <img src='/images/sup-photo-list.png' alt='Supplier List' style={{
                            maxWidth: '200px',
                            width: '100%'
                        }} />
                    </div>

                    <div className="position-relative" style={{ zIndex: 1 }}>
                        <ListSuppliers
                            handleSelectSupplier={handleSelectSupplier}
                            findSelectSupplier={findSelectSupplier}
                            handleSaveSuppliers={handleSaveSuppliers}
                            userToken={props.userToken}
                            language={language}
                        />
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={showBookingFrequencyModal}
                onHide={() => setShowBookingFrequencyModal(false)}
                centered
                size='lg'
                backdrop="static"
            >
                <Modal.Header closeButton className="modal-header no-border-bottom">
                    <Modal.Title>
                        <i className="bi bi-arrow-repeat icon-badge" style={{ padding: "4px 8px" }}></i>
                        {t('ModalBooking.bookingFrequencyTitleForm', language)}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center modal-pos">
                    <svg className="background-svg" viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2301_81)">
                            <ellipse cx="413.131" cy="422.366" rx="413.131" ry="422.366"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 965.542 1192.45)"
                                fill="var(--color-main-background)" />
                            <ellipse cx="516.414" cy="527.957" rx="516.414" ry="527.957"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1113.22 1195.26)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                            <ellipse cx="650.299" cy="664.835" rx="650.299" ry="664.835"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1304.66 1198.9)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2301_81">
                                <rect width="1920" height="1080" fill="white" transform="matrix(-1 0 0 1 1920 0)" />
                            </clipPath>
                        </defs>
                    </svg>

                    <div style={{ zIndex: 9999 }}>
                        <ErrorAlert message={errorMessage} setMessage={setErrorMessage} language={language} />
                    </div>

                    <div className="modal-Frequency" style={{ zIndex: 1 }}>
                        {app.theme === "dark" ? <img src='./images/TruckYardDark.png' alt='Truck Yard' /> : <img src='./images/TruckYard.png' alt='Truck Yard' />}
                    </div>

                    <div className="position-relative" style={{ zIndex: 1 }}>
                        <BookingFrequency
                            data={props.data}
                            userToken=''
                            warehouseid={props.warehouseid}
                            language={language}
                            onSelectBookingFrequency={(data) => setBookingFrequencyData(data)}
                            onClose={() => setShowBookingFrequencyModal(false)}
                            initialData={bookingFrequencyData}
                            selectTtimeSlot={props.selectTtimeSlot}
                            disableDuration={isDurationDisabled}
                        />
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
}
